import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as anamnesisReducer, REDUCER_NAME as ANAMNESIS_REDUCER } from './anamnesis'
import { reducer as listReducer, REDUCER_NAME as LIST_REDUCER } from './list'

const reducer = combineReducers({
    [ANAMNESIS_REDUCER]: anamnesisReducer,
    [LIST_REDUCER]: listReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/index.js